(function () {
  'use strict';

  var prompt = document.getElementById('scroll-to-begin');
  if (!prompt) return;

  function updateVisibility() {
    prompt.classList.toggle('is-hidden', window.scrollY > 12);
  }

  updateVisibility();
  window.addEventListener('scroll', updateVisibility, { passive: true });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var container = document.getElementById('scroll-to-begin-lottie');
  var animUrl = prompt.getAttribute('data-anim-url');
  if (!container || !animUrl) return;

  function mountAnimation() {
    if (typeof window.lottie === 'undefined') return;

    window.lottie.loadAnimation({
      container: container,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animUrl
    });
  }

  if (typeof window.lottie !== 'undefined') {
    mountAnimation();
    return;
  }

  var script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js';
  script.onload = mountAnimation;
  document.head.appendChild(script);
})();
